export const helperText = {
  suspendedBay:
    'Suspended bays are invalid parking locations, and will not show in the app.',
  enabledBay:
    'Enabled bays are locations in which a user may park a vehicle at the end of their journey.',
  promotionalBay:
    'Promotional bays are involved in Voucherify promotions, and are highlighted to users in-app. ' +
    'They should be marked as promotional for the duration of the promotion',
  priorityBay:
    'Priority bays are targetted for top up when at low capacity via automatically-raised distribution jobs.',
}
